import * as AdminUnenrollmentConstants from "./AdminUnenrollmentConstants";

// Object.assign is not yet fully supported in all browsers, so we fallback to a polyfill
const assign = Object.assign || require("object.assign");


const initialState = {
    isEnrollmentStateFetching: false,
    isEnrollmentStateFetched: false,
    isEnrollmentStateFetchFailed: false,
    deviceDemographics: [],
    isUnenrollInstrumentFetching: false,
    isUnenrollInstrumentFetched: false,
    isUnenrollInstrumentFetchFailed: false,
    unenrollmentInstrumentData: [],
    enrollmentStateFailureMessage:[],
};

/**'
 * redux reducer method which takes the current state and the action as input parameters and returns with the new state
 */
export default function EnrollmentStateReducer(state = initialState, action) {
    switch (action.type) {

        case AdminUnenrollmentConstants.ENROLLMENT_STATE_REQUESTS_FETCH_REQUEST:{

        const newState = {
              ...state,
              isEnrollmentStateFetching: true,
              isEnrollmentStateFetched: false,
              isEnrollmentStateFetchFailed: false,
              isUnenrollInstrumentFetching: false,
              isUnenrollInstrumentFetched: false,
              isUnenrollInstrumentFetchFailed: false,
        
        };
          return assign({}, state, newState);
         
        }

        case AdminUnenrollmentConstants.ENROLLMENT_STATE_REQUESTS_FETCH_SUCCESS:{
               console.log("state.deviceDemographics",state.deviceDemographics);
               const newState = {
                ...state,
                 isEnrollmentStateFetching: false,
                 isEnrollmentStateFetched: true,
                 isEnrollmentStateFetchFailed: false,
                 isUnenrollInstrumentFetching: false,
                 isUnenrollInstrumentFetched: false,
                 isUnenrollInstrumentFetchFailed: false,
                 unenrollmentInstrumentData: [action.payload,...state.unenrollmentInstrumentData],
              
              };
            return assign({}, state, newState);
          
          }
          

        case AdminUnenrollmentConstants.ENROLLMENT_STATE_REQUESTS_FETCH_ERROR:
          {  
            const newState = {
              ...state,
              isEnrollmentStateFetching: false,
              isEnrollmentStateFetched: false,
              isEnrollmentStateFetchFailed: true,
              isUnenrollInstrumentFetching: false,
              isUnenrollInstrumentFetched: false,
              isUnenrollInstrumentFetchFailed: false,
              enrollmentStateFailureMessage: action.payload?action.payload.message:AdminUnenrollmentConstants.ERROR_MESSAGE
            
            };
            
            return assign({}, state, newState);
            
          
          }

            case AdminUnenrollmentConstants.INSTRUMENT_UNENROLLMENT_REQUEST:{

              const newState = {
                ...state,
                isUnenrollInstrumentFetching: true,
                isUnenrollInstrumentFetched: false,
                isUnenrollInstrumentFetchFailed: false,
                isEnrollmentStateFetching: false,
                isEnrollmentStateFetched: false,
                isEnrollmentStateFetchFailed: false,
              };
              
              return assign({}, state, newState);
            }
            
  
          case AdminUnenrollmentConstants.INSTRUMENT_UNENROLLMENT_SUCCESS:{
              
            const newState = {
              ...state,
                  isUnenrollInstrumentFetching: false,
                isUnenrollInstrumentFetched: true,
                isUnenrollInstrumentFetchFailed: false,
                isEnrollmentStateFetching: false,
                isEnrollmentStateFetched: false,
                isEnrollmentStateFetchFailed: false,
                unenrollmentInstrumentData: action.payload,
            };
            
            return assign({}, state, newState);
            }
              
  
          case AdminUnenrollmentConstants.INSTRUMENT_UNENROLLMENT_ERROR:{

            const newState = {
              ...state,
              isUnenrollInstrumentFetching: false,
              isUnenrollInstrumentFetched: false,
              isUnenrollInstrumentFetchFailed: true,
              isEnrollmentStateFetching: false,
              isEnrollmentStateFetched: false,
              isEnrollmentStateFetchFailed: false,
              unenrollmentInstrumentData: action.payload,
            };
            
            return assign({}, state, newState);
             }
            

            case AdminUnenrollmentConstants.INSTRUMENT_UNENROLLMENT_UNMOUNT_CONDITION:{

                const newState = {
                  ...state,
                  isEnrollmentStateFetching: false,
                  isEnrollmentStateFetched: false,
                  isEnrollmentStateFetchFailed: false,
                  deviceDemographics: [],
                  isUnenrollInstrumentFetching: false,
                  isUnenrollInstrumentFetched: false,
                  isUnenrollInstrumentFetchFailed: false,
                  unenrollmentInstrumentData: [],
                  enrollmentStateFailureMessage:[],
                };
                
                return assign({}, state, newState);
               }
                
            
            
                case AdminUnenrollmentConstants.CLAER_INSTRUMENT_FROM_UNENROLLMENT_LIST:{

                  const newState = {
                    unenrollmentInstrumentData: action.payload
                  };
                  
                  return assign({}, state, newState);
                 }
            

              default:
            return state;

    }

}
